const locale = {
  message_success: '操作成功',
  message_info: '提示',
  message_warning: '注意',
  message_error: '操作失败'
};
export default locale;